module.exports = __webpack_public_path__ + "img/190.0cb5c72a.jpg";